export const IntroCode = `import { Confirm } from 'react-st-modal';

// ...
const onClick = async () => {
  const isConfirm = await Confirm(
    'You cannot undo this action',
    'Are you sure you want to delete the entry?'
  );

  if (isConfirm) {
    deleteRow();
  }
};`;

export const AlertExampleCode = `import { Alert } from 'react-st-modal';

function AlertExample() {
  return (
    <div>
      <button
        onClick={async () => {
          await Alert('Alert text', 'Alert title');
        }}
      >
          Alert
      </button>
    </div>
  );
}`;

export const ConfirmExampleCode = `import { Confirm } from 'react-st-modal';

function ConfirmExample() {
  return (
    <div>
      <button
        onClick={async () => {
          const result = await Confirm('Сonfirmation text', 
            'Сonfirmation title');
          
          if (result) {
            // Сonfirmation confirmed
          } else {
            // Сonfirmation not confirmed
          }
        }}
      >
        Confirm
      </button>
    </div>
  );
}`;

export const PromptExampleCode = `import { Prompt, Alert } from 'react-st-modal';

function PromptExample() {
  return (
    <div>
      <button
        onClick={async () => {
          const age = await Prompt('How old are you?', {
            isRequired: true,
            defaultValue: 100,
          });

          if (age) {
            Alert(\`You are \${age} years old!\`, 'Your age');
          }
        }}
      >
        Confirm
      </button>
    </div>
  );
}`;

export const CustomExampleCode = `import { CustomDialog, useDialog } from 'react-st-modal';

function CustomDialogContent() {
  const dialog = useDialog();

  const [value, setValue] = useState();

  return (
    <div>
      <input
        type="text"
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
      <button
        onClick={() => {
          // Сlose the dialog and return the value
          dialog.close(value);
        }}
      >
        Custom button
      </button>
    </div>
  );
}

function CustomExample() {
  return (
    <div>
      <button
        onClick={async () => {
          const result = await CustomDialog(<CustomDialogContent />, {
            title: 'Custom Dialog',
            showCloseIcon: true,
          });
        }}
      >
        Custom
      </button>
    </div>
  );
}
`;

export const CustomStaticCode = `import { StaticDialog, useDialog } from 'react-st-modal';

function CustomStaticExample() {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <StaticDialog
        isOpen={isOpen}
        title="Custom static dialog"
        onAfterClose={(result) => {
          setOpen(false);
          // do something with dialog result
        }}
      >
        {/* see previous demo */}
        <CustomDialogContent />
      </StaticDialog>
      <button
        onClick={() => {
          setOpen(true);
        }}
      >
        Custom static
      </button>
    </div>
  );
}`;

export const UICode = `import { ModalContent, ModalFooter, ModalButton, useDialog } from 'react-st-modal';

function CustomDialogContent() {
  const dialog = useDialog();

  const [value, setValue] = useState<string>();

  return (
      <div>
        <ModalContent>
          <div>Custom dialog content</div>
          <label>
            Input value:
            <input
              type="text"
              onChange={(e) => {
                setValue(e.target.value);
              }}
            />
          </label>
        </ModalContent>
        <ModalFooter>
          <ModalButton
            onClick={() => {
              dialog.close(value);
            }}
          >
            Custom button
          </ModalButton>
        </ModalFooter>
      </div>
  );
}`;

export const StyleCode = `:root {
    --st-modal-borderRadius: 0px;
    --st-modal-boxShadow: 0 10px 50px rgba(0, 0, 0, 0.8);

    --st-modal-backgroundColor: #2a2a2a;
    --st-modal-titleTextColor: #eeeeee;
    --st-modal-secondColor: #3c3c3c;

    --st-dialog-contentColor: #ffffff;

    --st-modal-transformVisible: translate3d(-50%, -50%, 0) scale(1);
    --st-modal-transformHidden: translate3d(-50%, -50%, 0) scale(0.1);

    --st-button-primaryColor: #dddddd;
    --st-button-primaryTextColor: #000000;
}
`;

export const AllCSSCode = `--st-overlay-color: rgba(0, 0, 0, 0.4);
--st-overlay-z-index: 1000;
--st-overlay-transition: opacity 0.6s cubic-bezier(0.25, 1, 0.5, 1);
--st-overlay-perspective: 1000px;

// MODAL WINDOW
--st-modal-minWidth: 300px;

--st-modal-borderRadius: 5px;
--st-modal-border: none;
--st-modal-boxShadow: 0 0 10px rgba(0, 0, 0, 0.3);

--st-modal-transformVisible: translate3d(-50%, -50%, 0) scale(1) rotateX(0);
--st-modal-transformHidden: translate3d(-50%, 100%, 0) scale(0.5) rotateX(-90deg);
--st-modal-transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);

--st-modal-backgroundColor: #ffffff;
--st-modal-titleTextColor: #444444;
--st-modal-secondColor: #f6f6f6;

// BUTTON
--st-button-dangerColor: #ff5c5c;
--st-button-dangerTextColor: #ffffff;

--st-button-primaryColor: #5d9aff;
--st-button-primaryTextColor: #ffffff;

--st-button-lightColor: #f6f6f6;
--st-button-lightTextColor: #444444;

--st-button-darkColor: #444444;
--st-button-darkTextColor: #f6f6f6;

--st-button-borderRadius: 6px;

// INPUT
--st-input-padding: 0.5rem;
--st-input-border: solid 1px #eeeeee;
--st-input-borderRadius: 6px;

// DIALOG
--st-dialog-baseWidth: 95%;
--st-dialog-maxWidth: 600px;
--st-dialog-padding: 1rem;
--st-dialog-maxContentHeight: 70vh;
--st-dialog-contentColor: #000000;`;
